import { useState } from 'react';
import { Star } from 'lucide-react';

interface StarRatingProps {
  value: number;
  onChange: (value: number) => void;
  label: string;
  disabled?: boolean;
}

const StarRating = ({ value, onChange, label, disabled = false }: StarRatingProps) => {
  const [hoverValue, setHoverValue] = useState<number | null>(null);

  const handleClick = (rating: number) => {
    if (!disabled) {
      onChange(rating);
    }
  };

  const handleMouseEnter = (rating: number) => {
    if (!disabled) {
      setHoverValue(rating);
    }
  };

  const handleMouseLeave = () => {
    if (!disabled) {
      setHoverValue(null);
    }
  };

  const displayValue = hoverValue !== null ? hoverValue : value;

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <div className="flex items-center space-x-1">
        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((rating) => {
          const isFilled = rating <= displayValue;
          return (
            <button
              key={rating}
              type="button"
              onClick={() => handleClick(rating)}
              onMouseEnter={() => handleMouseEnter(rating)}
              onMouseLeave={handleMouseLeave}
              disabled={disabled}
              className={`transition-colors ${
                disabled ? 'cursor-not-allowed' : 'cursor-pointer hover:scale-110'
              }`}
              aria-label={`Rate ${rating} out of 10`}
            >
              <Star
                className={`h-6 w-6 ${
                  isFilled
                    ? 'fill-accent-500 text-accent-500'
                    : 'fill-gray-200 text-gray-200'
                } ${!disabled && 'hover:fill-accent-400 hover:text-accent-400'}`}
              />
            </button>
          );
        })}
        {value > 0 && (
          <span className="ml-2 text-sm font-medium text-gray-700">
            {value}/10
          </span>
        )}
      </div>
    </div>
  );
};

export default StarRating;

